import Dialog from "@ergeon/core-components/exports/Dialog.ts";
import PopUp from "@ergeon/core-components/exports/PopUp.ts";
import { Permissions } from '@/app/types';

import { ExclamationTriangleIcon } from '@ergeon/icons/hero/solid';
import { AdjustmentsHorizontalIcon } from '@ergeon/icons/hero/mini';


interface ResetPermissionsModalProps {
  onClose(): void;
  permissions: Permissions;
}

export default function ResetPermissionsModal({ onClose, permissions }: ResetPermissionsModalProps) {
  const getPermissionsLabel = (permissions: Permissions): string => {
    const { audio, video } = permissions;
    return [audio && 'microphone', video && 'camera'].filter(Boolean).join(' and ');
  };

  return (
    <PopUp isVisible maxWidth="small" onChangeVisible={onClose}>
      <Dialog
        hideCancelButton
        icon={<ExclamationTriangleIcon className="size-6 text-orange-500 dark:text-orange-400" />}
        isVisible
        onDismiss={onClose}
        onSubmit={onClose}
        submitButtonFlavor="primary"
        submitButtonText="Ok"
        title="Grant permissions to continue">
        <ol className="list-inside list-decimal">
          <li className="mb-2">
            Click the <AdjustmentsHorizontalIcon className="inline-block size-5 align-text-bottom" /> in your browser's address bar
          </li>
          <li className="mb-2">
            Clear {getPermissionsLabel(permissions)} permission
          </li>
          <li className="mb-2">
            Refresh the page
          </li>
        </ol>
      </Dialog>
    </PopUp>
  );
}
